<div class="cookie__overlay"></div>

<div class="cookie-banner" data-testid="cookie-banner">
    <mat-card class="riege-card cookie-banner__inner" role="form" data-testid="cookie-consent-banner">
        <mat-card-content>
            <h2 i18n="@@consent-headline">Cookie settings</h2>
            <p
                ><span i18n="@@consent-description">We use cookies to improve and to analyse out website for you.</span
                ><br />
                <a href="/privacy-policy" target="_blank" class="cookie-banner__link" i18n="@@consent-link-privacy"
                    >Please see our privacy policy</a
                >.</p
            >

            <mat-divider class="margin-bottom--base"></mat-divider>

            <div class="cookie-banner__option-setting">
                <h3 i18n="@@consent-functional-headline">Functional</h3>
                <mat-slide-toggle checked disabled labelPosition="before"
                    ><span i18n="@@button-toggle-functional-cookies"
                        >Functional Cookies (always active)</span
                    ></mat-slide-toggle
                >
            </div>
            <p i18n="@@consent-functional-description"
                >Functional cookies allow us to save your settings and language choice, so that you can see this website
                in the correct language next time.</p
            >

            <div class="cookie-banner__option-setting">
                <h3 i18n="@@consent-tracking-headline">Statistic & Performance</h3>
                <mat-slide-toggle (toggleChange)="checked = !checked" [checked]="checked" labelPosition="before">{{
                    !checked ? disallowTracking : allowTracking
                }}</mat-slide-toggle>
            </div>
            <p class="margin-bottom--base-double" i18n="@@consent-tracking-description"
                >These optional cookies help us track website traffic and its sources. This allows us to measure and
                improve the performance of our website.</p
            >
        </mat-card-content>

        <mat-dialog-actions align="end">
            <button
                class="riege-button margin-bottom--base-mobile"
                mat-stroked-button
                (click)="checked = false; handleConsent()">
                {{ rejectAll }}</button
            >
            <button
                class="riege-button"
                mat-flat-button
                (click)="handleConsent()"
                data-testid="cookie-save"
                i18n="@@button-label-accept-selected"
                >Save selection</button
            >
        </mat-dialog-actions>
    </mat-card>
</div>
